<div class="container row center-center">
  @if (isEditing) {
    <input
      type="text"
      class="container__input item grow"
      [(ngModel)]="value"
      (keyup)="onKeyUp()"
      appFocusNextInput
      appFilterInput
      [allowNegativeValue]="true"
      [disabled]="isDisabled"
      (focusout)="onFocusOut()"
      #editInput
      />
  }
  @if (!isEditing) {
    <input
      type="text"
      class="container__input item grow"
      [(ngModel)]="value"
      (focusin)="onFocusIn()"
      />
  }

  <div class="container__description row justify-flex-end">
    <label>{{ description }}</label>
  </div>
</div>
